"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CaseStudiesCta() {
  const {
    ref: word1Ref,
    isVisible: word1Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const {
    ref: word2Ref,
    isVisible: word2Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const {
    ref: word3Ref,
    isVisible: word3Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="3501" id="case-studies-cta" className="relative bg-background text-foreground overflow-hidden py-24 md:py-40 lg:py-[200px] px-6 md:px-12 lg:px-20">
      {}
      <div className="hidden md:block absolute left-6 top-1/2 -translate-y-1/2 z-10">
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] block" style={{
        color: "var(--primary)",
        writingMode: "vertical-rl",
        transform: "rotate(180deg)"
      }}>
          CTA — WELLBEING
        </span>
      </div>

      {}
      <div className="hidden md:block absolute right-0 top-0 bottom-0 w-[2px] z-10" style={{
      background: "var(--primary)",
      boxShadow: "0 0 40px 8px var(--primary)"
    }} aria-hidden="true" />

      {}
      <div className="md:hidden absolute left-0 right-0 top-0 h-[2px] z-10" style={{
      background: "var(--primary)",
      boxShadow: "0 0 40px 4px var(--primary)"
    }} aria-hidden="true" />

      <div className="relative max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          {}
          <div className="lg:col-span-7 lg:col-start-1">
            <h2 className="font-default font-extrabold uppercase leading-[0.9] text-secondary text-[48px] sm:text-[60px] md:text-[80px] lg:text-[100px]" style={{
            letterSpacing: "-0.04em"
          }}>
              <span ref={word1Ref} data-index={0} className="block transition-all duration-700 ease-out" style={{
              opacity: word1Visible ? 1 : 0,
              transform: word1Visible ? "translateY(0)" : "translateY(40px)",
              transitionDelay: "0ms"
            }}>
                THESE RESULTS STARTED WITH A CONVERSATION.
              </span>
              <span ref={word2Ref} data-index={1} className="block transition-all duration-700 ease-out mt-4" style={{
              opacity: word2Visible ? 1 : 0,
              transform: word2Visible ? "translateY(0)" : "translateY(40px)",
              transitionDelay: "200ms",
              color: "var(--primary)"
            }}>
                BOOK A FREE INITIAL CONSULTATION.
              </span>
            </h2>
          </div>

          {}
          <div className="lg:col-span-5 lg:col-start-8 flex lg:justify-end">
            <div ref={cardRef} className="w-full lg:max-w-[440px] p-8 md:p-10 border border-border backdrop-blur-md transition-all duration-700 ease-out shadow-xl rounded-lg" style={{
            backgroundColor: "var(--card)",
            opacity: cardVisible ? 1 : 0,
            transform: cardVisible ? "translateX(0)" : "translateX(40px)",
            transitionDelay: "600ms"
          }}>
              {}
              <div className="font-mono text-[11px] uppercase tracking-[0.2em] mb-6" style={{
              color: "var(--secondary)"
            }}>
                STRATEGY AUDIT
              </div>

              {}
              <p className="font-default font-light text-base md:text-lg leading-relaxed text-muted-foreground mb-8">
                A comprehensive assessment to identify wellbeing risks, optimize your support systems, and design a thriving workplace environment.
              </p>

              {}
              <Button className="w-full h-14 uppercase font-default font-bold text-sm tracking-[0.15em] shadow-md hover:opacity-90 transition-opacity rounded-lg" style={{
              backgroundColor: "var(--primary)",
              color: "var(--primary-foreground)"
            }} onClick={() => window.location.href = "/Contact"}>
                Book a free consultation
                <ArrowRight className="ml-2 size-4" />
              </Button>

              {}
              <div className="mt-5 font-mono text-[11px] uppercase tracking-[0.18em]" style={{
              color: "var(--muted-foreground)"
            }}>
                GLOBAL CONSULTING — ONSITE + VIRTUAL
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}